import React from 'react';

import cl from 'classnames';

import { EBlockType, TBlock } from 'detailsv2/__blocks';
import { useLandingV2Context } from 'detailsv2/LandingV2/context';
import noop from 'utils/noop';

import Block from '../../../Block';
import { BlockContextProvider, useBlockContext } from '../../../Block/context';
import { AddNewContentWrapper } from '../../BlockWrapper';
import { IBlockConfig } from '../../types';
import { useChildrenBlocks } from './functions';
import s from './index.module.css';

export const ChildrenBlocksContent = ({
  showAloneAddNewContent: outerShowAloneAddNewContent = true,
  isVisible = true,
}: {
  showAloneAddNewContent?: boolean;
  isVisible?: boolean;
}) => {
  const { blockHandlersProvider: BlockHandlersProvider } = useLandingV2Context();
  const { index: parentBlockIndex, readonly, config, outerDisabledAddingBlocks } = useBlockContext();
  const { childrenBlocks, showAloneAddNewContent } = useChildrenBlocks();
  const hasOnlyMoreDetailsBlock = childrenBlocks?.length === 1 && childrenBlocks[0]?.type === EBlockType.MoreDetails;

  return (
    <div className={cl(s.block, { [s.visible]: isVisible, [s.onlyDetails]: hasOnlyMoreDetailsBlock })}>
      {outerShowAloneAddNewContent && showAloneAddNewContent && <AloneAddNewContent index={[...parentBlockIndex, 0]} />}
      {childrenBlocks?.map((block, index) => {
        if (block === null) return null;

        return (
          <BlockHandlersProvider key={`${index}-${block.id}`} index={[...parentBlockIndex, index]}>
            {({
              onAdd,
              onUpdate,
              onDelete,
              onAddBlockInsideSpoiler,
              onUpdateBlockInsideSpoiler,
              onDeleteBlockInsideSpoiler,
            }) => (
              <Block
                readonly={readonly}
                disabledAddingBlocks={config.disabledAddingBlocksForChildren ?? outerDisabledAddingBlocks}
                block={block as TBlock}
                index={[...parentBlockIndex, index]}
                onAdd={onAdd}
                onUpdate={onUpdate}
                onDelete={onDelete}
                onAddBlockInsideSpoiler={onAddBlockInsideSpoiler}
                onUpdateBlockInsideSpoiler={onUpdateBlockInsideSpoiler}
                onDeleteBlockInsideSpoiler={onDeleteBlockInsideSpoiler}
              />
            )}
          </BlockHandlersProvider>
        );
      })}
    </div>
  );
};

function AloneAddNewContent({ index }: { index: number[] }) {
  const value = { block: {} as TBlock, index, config: {} as IBlockConfig };

  return (
    <BlockContextProvider value={value}>
      <AddNewContentWithOwnBlockHandlersProvider />
    </BlockContextProvider>
  );
}

function AddNewContentWithOwnBlockHandlersProvider() {
  const { blockHandlersProvider: BlockHandlersProvider } = useLandingV2Context();
  const { index } = useBlockContext();

  return (
    <BlockHandlersProvider index={index}>
      {({ onAdd }) => {
        return <AddNewContentWrapper onAdd={onAdd} onOpenPopup={noop} onClosePopup={noop} alwaysShow />;
      }}
    </BlockHandlersProvider>
  );
}
